import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

// Exibição (somente leitura) das metas do mês atual, definidas pelo admin —
// usada em destaque na tela Hoje e dentro da Evolução Física da aluna.
export default function MetasMesCard({ alunaId, titulo, showEmpty = false, lang = 'pt' }) {
  const [metas, setMetas] = useState([]);
  const [loading, setLoading] = useState(true);
  const mesAno = new Date().toISOString().slice(0, 7);

  useEffect(() => {
    if (!alunaId) return;
    supabase.from('metas_mes').select('*').eq('aluna_id', alunaId).eq('mes_ano', mesAno).order('criado_em')
      .then(({ data }) => { setMetas(data || []); setLoading(false); });
  }, [alunaId, mesAno]);

  if (loading) return null;
  if (metas.length === 0 && !showEmpty) return null;

  return (
    <section className="hoje-metas">
      <div className="hoje-section-head">
        <h2>{titulo || (lang === 'pt' ? 'Metas do mês' : 'Monthly goals')}</h2>
        <span>{new Date().toLocaleDateString(lang === 'pt' ? 'pt-BR' : 'en-US', { month: 'long' })}</span>
      </div>
      <div className="hoje-goals">
        {metas.length === 0 && (
          <article className="hoje-goal hoje-goal-empty">
            <p>{lang === 'pt' ? 'Suas metas do mês ainda não foram cadastradas.' : 'Your monthly goals have not been set yet.'}</p>
          </article>
        )}
        {metas.map((m, index) => (
          <article key={m.id} className={`hoje-goal hoje-goal-${index % 3}`}>
            <div className="hoje-goal-icon"><span>{index + 1}</span></div>
            <div className="hoje-goal-main">
              <h3>{m.titulo}</h3>
              {m.meta && <p>{m.meta}</p>}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
